import React from 'react';
import { useGardenLayouts } from '../hooks/useGardenLayouts';
import GardenLayoutCard from '../components/layouts/GardenLayoutCard';
import { Loader2, LayoutGrid } from 'lucide-react';

export default function GardenLayouts() {
  const { layouts, loading, error } = useGardenLayouts();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-100">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 text-primary-600 mb-3">
              <LayoutGrid className="h-5 w-5" />
              <span className="text-sm font-medium uppercase tracking-wider">Garden Layouts</span>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 font-dm-serif mb-4">
              Garden A Day
            </h1>
            <p className="text-lg text-gray-600">
              Every day we design a new garden layout — sized for real spaces, planted with real plants,
              and shared on social media. Browse all of them here, or download any layout to print and use
              in your own garden.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-10">
        {loading ? (
          <div className="flex justify-center py-20">
            <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
          </div>
        ) : error ? (
          <div className="text-center py-20">
            <p className="text-red-600">{error}</p>
          </div>
        ) : layouts.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-gray-500">No layouts posted yet — check back soon.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {layouts.map((layout) => (
              <GardenLayoutCard key={layout.id} layout={layout} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
